import InputNumber from 'antd/lib/input-number'
import type { InputNumberProps as AntdInputNumberProps } from 'antd/lib/input-number'
import { connectReadonlyComponent } from '../connect'
import PreviewText from '../preview-text'

import 'antd/lib/input-number/style'

export * from 'antd/lib/input-number'

export type InputNumberProps = AntdInputNumberProps & {
  readonly?: boolean
}

export default connectReadonlyComponent(InputNumber, PreviewText.Input)
